import { withContext } from 'components/withContext';
import { createContext } from 'react';

const LanguageContext = createContext();
const LanguageConsumer = withContext(LanguageContext, 'language');

export { LanguageContext, LanguageConsumer };
